export default "__VITE_ASSET__Bav_qRmu__"